import { Directive, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReferenceDataLabels } from '../../../lib/constants/reference-data-labels';
import { MortgageApplicationStore } from './../services/mortgage-application-store';
import { MortgageApplicationService } from './../services/mortgage-application.service';

@Directive()
export abstract class BaseSaveSectionComponent implements OnDestroy {
  @Input() public isFieldDisabled: boolean;
  @Input() public saveButtonLabel: string;

  public readonly referenceDataLabels = ReferenceDataLabels;

  protected readonly destroySubject$ = new Subject();

  private numberOfNotSavedApplicants: number;
  private numberOfSavedApplicants: number;
  private readonly applicantTabUrl = '/applicant/';

  constructor(
    protected readonly mortgageApplicationStore: MortgageApplicationStore,
    protected readonly mortgageApplicationService: MortgageApplicationService,
    protected readonly router: Router,
    public readonly route: ActivatedRoute
  ) {}

  public refreshApplication(): void {
    const isApplicationReadonly =
      this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity.IsApplicationReadOnly;
    const isFactFindReadonly =
      this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity.IsFactFindReadOnly;

    const applicationId = this.route.parent.snapshot.params['applicationId'];

    this.mortgageApplicationService
      .loadMortgageApplication(applicationId)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data) => {
        data.mortgageApplicationEntity.IsApplicationReadOnly = isApplicationReadonly;
        data.mortgageApplicationEntity.IsFactFindReadOnly = isFactFindReadonly;
        this.numberOfNotSavedApplicants =
          this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity.Applicants.length;
        this.mortgageApplicationStore.mortgageApplicationResponse = data;
        this.handleNewApplicantsNotSaved();
      });
  }

  private handleNewApplicantsNotSaved(): void {
    this.numberOfSavedApplicants =
      this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity.Applicants.length;
    if (
      this.router.url.includes(this.applicantTabUrl) &&
      this.numberOfNotSavedApplicants > this.numberOfSavedApplicants
    ) {
      const lastApplicantIndex = this.numberOfSavedApplicants - 1;
      void this.router.navigate(['../', lastApplicantIndex], { relativeTo: this.route });
    }
  }

  public ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
